module.exports = __webpack_public_path__ + "img/sm-whatsapp.0e746bb0.svg";